import {useStores} from "../Hooks";
import {responseEnum} from "../serverClientShared/sharedEnums";

const ShowErrorModalStoreHook = () => {
    const {modalStore, generalStore} = useStores();

    function ShowErrorModalStore(e) {
        switch (e.response.status) {
            case responseEnum.PAYLOAD_TOO_LARGE:
                modalStore.showErrorMessage(generalStore.translate('fileTooLarge2GB'));
                break;
            case responseEnum.NO_PERMISSION:
                modalStore.showErrorMessage(generalStore.translate('cannotUploadFileOfThisType'));
                break;
            case responseEnum.NOT_EXISTS:
                modalStore.showErrorMessage(generalStore.translate('notFound'));
                break;
            default:
                modalStore.showErrorMessage(generalStore.translate('problemUploadingProcedure'), true);
                break;
        }
    }

    return ShowErrorModalStore
}

export default ShowErrorModalStoreHook;